import { Component } from "react";
import React from "react";
import "./About.css";
import { Box, Typography, Grid, Card } from "@mui/material";
import Navbar from "../../Home/Components/Nav";
import Footer from "../../Home/Components/Footer";
import VerifiedIcon from "@mui/icons-material/Verified";
import SupportAgentIcon from "@mui/icons-material/SupportAgent";
import BuildIcon from "@mui/icons-material/Build";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import EmojiEventsIcon from "@mui/icons-material/EmojiEvents";
import PeopleIcon from "@mui/icons-material/People";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import DirectionsCarIcon from "@mui/icons-material/DirectionsCar";

const heritage =
  "https://firebasestorage.googleapis.com/v0/b/mgcentral-a28cf.firebasestorage.app/o/home%2Fa663b05c-3f50-49fc-850e-e6d20707336f.jpg?alt=media&token=e49d4331-ac38-48b7-b508-00d836827d1d";
const company =
  "https://firebasestorage.googleapis.com/v0/b/mgcentral-a28cf.firebasestorage.app/o/home%2F88efc195-4ceb-4131-ba52-1ca7fee416a5.jpg?alt=media&token=a8d85b89-ebc4-4991-b7e1-db04fa40224b";

const stats = [
  {
    value: "100+",
    label: "Years of Heritage",
    icon: <EmojiEventsIcon sx={{ fontSize: { xs: 34, md: 40 }, color: "rgba(255,255,255,0.9)" }} />,
  },
  {
    value: "5000+",
    label: "Happy Customers",
    icon: <PeopleIcon sx={{ fontSize: { xs: 34, md: 46 }, color: "rgba(255,255,255,0.9)" }} />,
  },
  {
    value: "6+",
    label: "Locations",
    icon: <LocationOnIcon sx={{ fontSize: { xs: 34, md: 46 }, color: "rgba(255,255,255,0.9)" }} />,
  },
  {
    value: "10+",
    label: "MG Models",
    icon: <DirectionsCarIcon sx={{ fontSize: { xs: 34, md: 46 }, color: "rgba(255,255,255,0.9)" }} />,
  },
];

const features = [
  {
    icon: <VerifiedIcon sx={{ fontSize: 48, color: "#D12230" }} />,
    title: "Certified Excellence",
    desc: "Every vehicle undergoes a rigorous 150-point inspection before delivery, ensuring top quality and reliability.",
  },
  {
    icon: <SupportAgentIcon sx={{ fontSize: 48, color: "#D12230" }} />,
    title: "Expert Team",
    desc: "Our MG-trained professionals are committed to delivering the finest customer experience from showroom to road.",
  },
  {
    icon: <BuildIcon sx={{ fontSize: 48, color: "#D12230" }} />,
    title: "Genuine Parts",
    desc: "We use only authentic MG-certified parts to keep your vehicle performing at its peak for years to come.",
  },
  {
    icon: <AccountBalanceIcon sx={{ fontSize: 48, color: "#D12230" }} />,
    title: "Flexible Finance",
    desc: "Competitive financing plans tailored to your budget, making your dream MG a reality today.",
  },
];

class About extends Component {
  render() {
    return (
      <div id="container">
        <Navbar />

        {/* Hero Banner */}
        <div id="banner-image-about">
          <div id="write">
            <Typography
              variant="h4"
              sx={{
                fontFamily: "Roboto, sans-serif",
                fontWeight: "bold",
                textAlign: "center",
                fontSize: { md: "38px", xs: "20px", sm: "28px" },
                color: "white",
                letterSpacing: "2px",
                px: 2,
              }}
            >
              DEDICATED TO MOTORING EXPERIENCES SINCE 1924
            </Typography>
          </div>
        </div>

        {/* Stats Bar */}
        <Box
          sx={{
            background: "linear-gradient(135deg, #D12230 0%, #8B0000 100%)",
            py: { xs: 2, md: 2 },
            px: 2,
          }}
        >
          <Grid container spacing={2} justifyContent="center">
            {stats.map((stat, i) => (
              <Grid item xs={6} sm={3} key={i}>
                <Box sx={{ textAlign: "center", color: "white", py: 1 }}>
                  <Box sx={{ lineHeight: 1, mb: 0.5 }}>{stat.icon}</Box>
                  <Typography
                    sx={{
                      fontWeight: "bold",
                      fontSize: { xs: "18px", md: "30px" },
                      fontFamily: "Roboto, sans-serif",
                      lineHeight: 1.1,
                      mt: 0.5,
                    }}
                  >
                    {stat.value}
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: { xs: "11px", md: "15px" },
                      opacity: 0.9,
                      fontFamily: "Roboto, sans-serif",
                      mt: 0.5,
                    }}
                  >
                    {stat.label}
                  </Typography>
                </Box>
              </Grid>
            ))}
          </Grid>
        </Box>

        {/* About MG Central */}
        <Box sx={{ py: { xs: 4, md: 8 }, px: { xs: 2, md: 8 }, backgroundColor: "#fff" }}>
          <Grid container spacing={5} alignItems="center">
            <Grid item xs={12} md={6}>
              <Box
                component="img"
                src={heritage}
                alt="heritage"
                sx={{
                  width: "100%",
                  height: { xs: "240px", md: "420px" },
                  objectFit: "cover",
                  borderRadius: "16px",
                  boxShadow: "0 12px 40px rgba(0,0,0,0.15)",
                }}
              />
            </Grid>
            <Grid
              item
              xs={12}
              md={6}
              sx={{ display: "flex", flexDirection: "column", justifyContent: "center" }}
            >
              <Typography
                sx={{
                  color: "#D12230",
                  fontWeight: "bold",
                  fontSize: "12px",
                  letterSpacing: "3px",
                  textTransform: "uppercase",
                  mb: 1,
                  fontFamily: "Roboto, sans-serif",
                }}
              >
                Our Story
              </Typography>
              <Typography
                variant="h4"
                sx={{
                  fontWeight: "bold",
                  fontFamily: "Roboto, sans-serif",
                  color: "#1a1a1a",
                  mb: 3,
                  fontSize: { xs: "22px", md: "32px" },
                }}
              >
                About MG Central
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  fontFamily: "LatoGoogle, Lato, LatoWeb, sans-serif",
                  fontSize: { xs: "13px", sm: "15px", md: "15px" },
                  color: "#555",
                  lineHeight: 1.9,
                  mb: 2,
                }}
              >
                Welcome to MG Central, your premier MG showroom and trusted destination for the latest MG cars in Odisha. We proudly showcase a wide range of MG models, including cutting-edge SUVs and stylish sedans, each designed to offer superior technology, performance, and style. Our goal is to provide you with a smooth, transparent car-buying experience that helps you find the perfect MG vehicle to match your lifestyle.
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  fontFamily: "LatoGoogle, Lato, LatoWeb, sans-serif",
                  fontSize: { xs: "13px", sm: "15px", md: "15px" },
                  color: "#555",
                  lineHeight: 1.9,
                }}
              >
                At MG Central, we prioritize exceptional customer service, with a team ready to guide you through every step—from exploring our MG models to understanding financing options. Located in Bhubaneswar, MG Central is dedicated to making your car-buying journey as seamless and enjoyable as possible. Discover the reliability, innovation, and quality that define MG. Visit MG Central in Khandagiri, Bhubaneswar today, and experience a new level of driving confidence and satisfaction.
              </Typography>
            </Grid>
          </Grid>
        </Box>

        {/* Why Choose MG Central */}
        <Box sx={{ py: { xs: 5, md: 9 }, px: { xs: 2, md: 6 }, backgroundColor: "#f7f7f7" }}>
          <Typography
            sx={{
              color: "#D12230",
              fontWeight: "bold",
              fontSize: "12px",
              letterSpacing: "3px",
              textTransform: "uppercase",
              textAlign: "center",
              mb: 1,
              fontFamily: "Roboto, sans-serif",
            }}
          >
            Our Promise
          </Typography>
          <Typography
            variant="h4"
            align="center"
            sx={{
              fontWeight: "bold",
              fontFamily: "Roboto, sans-serif",
              color: "#1a1a1a",
              mb: 5,
              fontSize: { xs: "22px", md: "32px" },
            }}
          >
            Why Choose MG Central?
          </Typography>
          <Grid container spacing={3} justifyContent="center">
            {features.map((feature, i) => (
              <Grid item xs={12} sm={6} md={3} key={i}>
                <Card
                  elevation={0}
                  sx={{
                    textAlign: "center",
                    p: { xs: 3, md: 4 },
                    height: "100%",
                    border: "1.5px solid #eee",
                    borderRadius: "20px",
                    backgroundColor: "#fff",
                    transition: "all 0.35s ease",
                    cursor: "default",
                    "&:hover": {
                      transform: "translateY(-10px)",
                      boxShadow: "0 20px 50px rgba(209,34,48,0.13)",
                      borderColor: "#D12230",
                    },
                  }}
                >
                  <Box sx={{ mb: 2 }}>{feature.icon}</Box>
                  <Typography
                    variant="h6"
                    sx={{
                      fontWeight: "bold",
                      fontFamily: "Roboto, sans-serif",
                      color: "#1a1a1a",
                      mb: 1.5,
                      fontSize: { xs: "16px", md: "18px" },
                    }}
                  >
                    {feature.title}
                  </Typography>
                  <Typography
                    variant="body2"
                    sx={{
                      color: "#666",
                      fontFamily: "Roboto, sans-serif",
                      lineHeight: 1.8,
                      fontSize: "13px",
                    }}
                  >
                    {feature.desc}
                  </Typography>
                </Card>
              </Grid>
            ))}
          </Grid>
        </Box>

        {/* About Central Group */}
        <Box sx={{ py: { xs: 4, md: 8 }, px: { xs: 2, md: 8 }, backgroundColor: "#fff" }}>
          <Grid container spacing={5} alignItems="center">
            <Grid
              item
              xs={12}
              md={6}
              sx={{
                order: { xs: 2, md: 1 },
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
              }}
            >
              <Typography
                sx={{
                  color: "#D12230",
                  fontWeight: "bold",
                  fontSize: "12px",
                  letterSpacing: "3px",
                  textTransform: "uppercase",
                  mb: 1,
                  fontFamily: "Roboto, sans-serif",
                }}
              >
                Our Parent Company
              </Typography>
              <Typography
                variant="h4"
                sx={{
                  fontWeight: "bold",
                  fontFamily: "Roboto, sans-serif",
                  color: "#1a1a1a",
                  mb: 3,
                  fontSize: { xs: "22px", md: "32px" },
                }}
              >
                About Central Group
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  fontFamily: "LatoGoogle, Lato, LatoWeb, sans-serif",
                  fontSize: { xs: "13px", sm: "15px", md: "14px" },
                  color: "#555",
                  lineHeight: 1.9,
                  mb: 2,
                }}
              >
                Central Group is a premier automotive network serving Odisha and beyond, known for representing top automobile brands such as Kia, Honda, Renault, Tata Small Commercial Vehicle, and MG Motors &amp; BYD. Our extensive dealership network includes showrooms in Sambalpur, Angul, Jharsuguda, Jajpur, Bhubaneswar, Cuttack, Puri, Nayagarh, Berhampur, Ganjam, Phulbani, and Vizag. We provide exceptional customer service and a wide selection of new and certified pre-owned vehicles, catering to a diverse range of needs and preferences.
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  fontFamily: "LatoGoogle, Lato, LatoWeb, sans-serif",
                  fontSize: { xs: "13px", sm: "15px", md: "14px" },
                  color: "#555",
                  lineHeight: 1.9,
                }}
              >
                With a commitment to quality and transparency, Central Group ensures a premium car-buying experience where customers can explore the latest models and find reliable, budget-friendly options. Our deep industry expertise and dedication to customer satisfaction have helped us build a strong reputation in the automotive sector. Proudly serving the community across multiple locations, we help drivers and families find vehicles that match their lifestyle, budget, and taste. Discover why so many choose Central Group for a seamless and rewarding car-buying journey backed by reliability, variety, and trusted support.
              </Typography>
            </Grid>
            <Grid item xs={12} md={6} sx={{ order: { xs: 1, md: 2 } }}>
              <Box
                component="img"
                src={company}
                alt="Central Group"
                sx={{
                  width: "100%",
                  height: { xs: "240px", md: "420px" },
                  objectFit: "cover",
                  borderRadius: "16px",
                  boxShadow: "0 12px 40px rgba(0,0,0,0.15)",
                }}
              />
            </Grid>
          </Grid>
        </Box>

        {/* CTA Banner */}
        <Box
          sx={{
            background: "linear-gradient(135deg, #1a1a1a 0%, #3a3a3a 100%)",
            py: { xs: 5, md: 7 },
            px: 2,
            textAlign: "center",
          }}
        >
          <Typography
            variant="h4"
            sx={{
              color: "white",
              fontFamily: "Roboto, sans-serif",
              fontWeight: "bold",
              fontSize: { xs: "20px", md: "32px" },
              mb: 2,
            }}
          >
            Ready to Experience the MG Difference?
          </Typography>
          <Typography
            sx={{
              color: "rgba(255,255,255,0.75)",
              fontFamily: "Roboto, sans-serif",
              fontSize: { xs: "13px", md: "16px" },
              mb: 4,
            }}
          >
            Visit MG Central in Khandagiri, Bhubaneswar and drive home your dream car today.
          </Typography>
          <Box
            component="a"
            href="/contactUs"
            sx={{
              display: "inline-block",
              backgroundColor: "#D12230",
              color: "white",
              px: 5,
              py: 1.8,
              borderRadius: "50px",
              fontWeight: "bold",
              fontSize: { xs: "13px", md: "16px" },
              textDecoration: "none",
              fontFamily: "Roboto, sans-serif",
              letterSpacing: "1px",
              transition: "background 0.3s",
              "&:hover": { backgroundColor: "#a81a27" },
            }}
          >
            CONTACT US
          </Box>
        </Box>

        <Footer />
      </div>
    );
  }
}

export default About;
